module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "fm-title1"
  }, [_vm._v("AUTHOR’S NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("I chose hope as the theme for this book because, quite simply, without hope there is nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Hope floats, it rises, it grows wild in the most deprived soil and it can be the very difference between life and death.")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("We have all heard stories of humans enduring the unthinkable and surviving – no, "), _c('i', [_vm._v("thriving")]), _vm._v(". Listen to what they say and you will find hope in every chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Hope exists when nothing else can and it is an invisible yet powerful force we can all harness from day to day. I watch people with avid fascination. I read their tales of endurance and struggle and I consume the hope they readily drip from every word. You will find all of that hard-won inspiration on these pages, to remind you of what you already know to be true … you simply must have hope. It is the light. It is the key. It is the fuel. And when you cannot find yours, you can happily borrow mine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-744cd80e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm2.vue
// module id = 81
// module chunks = 0